import register from '../util/init'
import { debounce } from './tools'
import { get } from '../util/fetch'
import { dashboard } from './dashboard'

function onLoad() {
  const adviserFilter = document.querySelector('.filters__adviser')
  const portfoliosSmall = document.querySelector('.portfolios__small-profile')
  const portfoliosSort = document.querySelector('.filters__sort')
  const table = document.querySelector('.portfolio-list__table')
  const portfoliosSearch = document.querySelector('.filters__search')
  let value = portfoliosSearch.value
  if (value === '' || value === '%20') {
    value = 'all'
  }

  if (adviserFilter.options[adviserFilter.selectedIndex].value !== 'all') {
    window
      .fetch(
        'get/?id=' +
          adviserFilter.value +
          '&search=' +
          value +
          '&sort=' +
          portfoliosSort.value,
        {
          credentials: 'include'
        }
      )
      .then(response => {
        return response.json()
      })
      .then(JsonResponse => {
        portfoliosSmall.innerHTML = JsonResponse.profile_template
        table.innerHTML = JsonResponse.table_template
        // initPortfolioLinks()
      })
  }

  // const portfolioListItem = document.querySelector('.portfolio-list__title a')

  // const portfolioDetail = document.querySelector('.portfolios__detail')
  // window
  //   .fetch('detail/' + portfolioListItem.dataset.portfolioid, {
  //     credentials: 'include',
  //     headers: {
  //       'X-Requested-With': 'XMLHttpRequest'
  //     }
  //   })
  //   .then(response => {
  //     return response.json()
  //   })
  //   .then(jsonResponse => {
  //     portfolioDetail.innerHTML = jsonResponse.response
  //     dashboard('', 0, '', portfolioListItem.dataset.portfolioid)
  //   })
}

function onPortfolioSelect(e) {
  e.preventDefault()
  const portfolioDetail = document.querySelector('.portfolios__detail')

  window
    .fetch('detail/' + e.target.dataset.portfolioid, {
      credentials: 'include'
    })
    .then(response => {
      return response.json()
    })
    .then(jsonResponse => {
      portfolioDetail.innerHTML = jsonResponse.response
      dashboard('', 0, e.target.dataset.portfolioid)
    })
}

function onAdviserFilterChange() {
  const portfoliosSmall = document.querySelector('.portfolios__small-profile')
  const portfoliosSort = document.querySelector('.filters__sort')
  const adviserFilter = document.querySelector('.filters__adviser')
  const table = document.querySelector('.portfolio-list__table')

  window
    .fetch(
      'get/?id=' +
        adviserFilter.value +
        '&search=all&sort=' +
        portfoliosSort.value,
      {
        credentials: 'include'
      }
    )
    .then(response => {
      return response.json()
    })
    .then(JsonResponse => {
      if (adviserFilter.value === 'all') {
        portfoliosSmall.innerHTML = ''
      } else {
        portfoliosSmall.innerHTML = JsonResponse.profile_template
      }
      table.innerHTML = JsonResponse.table_template
      // initPortfolioLinks()
    })
}

function onSearchChange(e) {
  const portfoliosSmall = document.querySelector('.portfolios__small-profile')
  const portfoliosSort = document.querySelector('.filters__sort')
  const table = document.querySelector('.portfolio-list__table')

  let value = e.target.value
  if (e.target.value === '' || e.target.value === '%20') {
    value = 'all'
  }

  window
    .fetch('get/?id=all&search=' + value + '&sort=' + portfoliosSort.value, {
      credentials: 'include'
    })
    .then(response => {
      return response.json()
    })
    .then(JsonResponse => {
      if (e.target.value === 'all') {
        portfoliosSmall.innerHTML = ''
      } else {
        portfoliosSmall.innerHTML = JsonResponse.profile_template
      }
      table.innerHTML = JsonResponse.table_template
      // initPortfolioLinks()
    })
}

function fixTableHead() {
  const portfolioListHead = document.querySelector('.portfolio-list__table tr')
  let rect = portfolioListHead.getBoundingClientRect()

  if (window.scrollY > rect.top + 350) {
    portfolioListHead.classList.add('fixed')
  } else {
    portfolioListHead.classList.remove('fixed')
  }
}

function initPortfolioLinks() {
  const portfolioListItem = document.querySelectorAll(
    '.portfolio-list__title a'
  )
  portfolioListItem.forEach(item => {
    item.addEventListener('click', e => onPortfolioSelect(e))
  })
}

function portfolios(container) {
  const adviserFilter = document.querySelector('.filters__adviser')
  const portfoliosSort = document.querySelector('.filters__sort')
  const portfoliosSearch = document.querySelector('.filters__search')

  onLoad()

  // window.addEventListener('scroll', () => fixTableHead())

  adviserFilter.addEventListener('change', e => onAdviserFilterChange())
  portfoliosSort.addEventListener('change', e => onAdviserFilterChange())
  portfoliosSearch.addEventListener(
    'keyup',
    debounce(e => onSearchChange(e), 300)
  )
  // initPortfolioLinks()
}

register('.portfolios', portfolios)



// WEBPACK FOOTER //
// ./assets/j/src/portfolios.js